import styles from "./Conta.module.css";

function Conta({ user }){
    return (
        <div className={styles.conta}>
            <div className={styles.topic}>
            Id: {user.id}
            </div>
            <div className={styles.topic}>
                <span className={styles.title}>Username:</span> {user.username}
            </div>
            <div className={styles.topic}>
                <span className={styles.title}>Email:</span> {user.email}
            </div>
            <div className={styles.topic}>
                <span className={styles.title}>Cargo:</span> {user.role}
            </div>
            <div className={`${styles.topic} ${styles.top}`}>
                <span className={styles.title}>Pagamentos realizados:</span> 0
            </div>
            <div className={`${styles.topic} ${styles.bottom}`}>
                <span className={styles.title}>Valor em Pagamentos:</span> 0R$
            </div>
            <div className={styles.topic}>
                <span className={styles.title}>Conta criada em</span> {user.created}
            </div>
        </div>
    )
}

export default Conta;